export const FORMAT = 'dd.MM.yyyy';
